import { Controller } from '@hotwired/stimulus';

// A missing or broken remote image would otherwise show the browser's broken-image glyph,
// clipped by the avatar's round frame. Swap in the default avatar instead.
export default class extends Controller {
  static values = { fallbackSrc: String };

  connect() {
    // The error can fire before this controller connects.
    if (this.element.complete && this.element.naturalWidth === 0) this.fallback();
  }

  fallback() {
    if (this.fellBack) return;

    this.fellBack = true;
    this.element.src = this.fallbackSrcValue;
  }
}
